import React from 'react'

import classnames from 'classnames'

type Props = {
  expanded?: boolean
}

const DropdownArrow = ({ expanded }: Props) => (
  <div
    aria-hidden='true'
    className={classnames('dropDownArrow', { expanded })}
  ></div>
)

export default DropdownArrow
